import NewRequestHistoryReducer from "./reducer/NewRequestSlice"
import SupplierRequestHistoryReducer from "./reducer/SupplierRequestHistorySlice"
import AllSupplierHistorySlice from "./reducer/AllSupplierSlice"
import BusinessTypeReducer from "./reducer/BusinessTypeSlice"
import VendorNeedListReducer from "./reducer/VendorNeedSlice"
import AssesmentMasterListingReducer from "./reducer/AssesmentMasterSlice"
import SpecializationReducer from './reducer/AllSpecialization';
import SelfAssesmentReducer from "./reducer/AllSelfAssesmentQuestion"
import AuditPersonReducer from './reducer/AllAuditPerson';
import LegalDocumentReducer from './reducer/AllLegalDocument';
import ReviewQuestionReducer from './reducer/AllReviewQuestions'
import getAllVendorNeedApprovalReducer from "./reducer/AllVendorNeedApproval";
import NsaListReducer from "./reducer/NsaListReducer"
import getAllAssignCftReducer from "./reducer/getAllAssignCftReducer"
import PendingAuditListReducer from "./reducer/PendingAuditListReducer"
import ViewDetailReportReducer from "./reducer/ViewDetailReportReducer"
import ImprovementPlanReducer from "./reducer/ImprovementPlanReducer"
import AllpendingForApprovalReducer from "./reducer/AllpendingForApprovalReducer"
import ReviewRequestResponseApproverReducer from "./reducer/ReviewRequestResponseApproverReducer"
import ExceptionApprovalListReducer from "./reducer/ExceptionApprovalListReducer"
import PaymentMasterReducer from "./reducer/AllPaymentMasterList"
import AllAwaitingForApprover from "./reducer/AllAwaitingForApprover"
import EmailTrackListReducer from "./reducer/EmailTrackListReducer"
import VendorNeedFormApprovalList from "./reducer/VendorNeedFormApprovalList"
import VendorNeedFormPendingList from "./reducer/VendorNeedFormPendingList"
import NewRequestHistoryExport from "./reducer/NewRequestHistoryExport"
import SocMasterReducer from "./reducer/SocMasterReducer"
import getAllSupplierNeedApproval from "./reducer/AllSupplierNeedApproval"
import SupplierCertificateMaster from "./reducer/AllSupplierCategoryMaster"
import ReconciliationReducer from "./reducer/ReconciliationReducer"
import AccountGroupMappingReducer from "./reducer/AccountGroupMappingReducer"
import CompanyCodeReducer from "./reducer/AllCompanyCodeList "
import UnblockListReducer from "./reducer/AllunblockList"
import AuditTrailListReducer from "./reducer/AuditTrailList"
import BlockedSupplierRequest from "./reducer/BlockedSupplierRequest"

const mainReducer = {
    NewRequestSupplierHistory: NewRequestHistoryReducer,
    VendorNeedList: VendorNeedListReducer,
    SupplierRequestHistoryReducer: SupplierRequestHistoryReducer,
    BusinessTypeReducer: BusinessTypeReducer,
    AuditTrailListReducer: AuditTrailListReducer,
    AssesmentMasterList: AssesmentMasterListingReducer,
    AllSupplierHistorySlice: AllSupplierHistorySlice,
    SpecializationReducer: SpecializationReducer,
    PaymentMasterReducer: PaymentMasterReducer,
    SelfAssesmentReducer: SelfAssesmentReducer,
    AuditPersonReducer: AuditPersonReducer,
    getAllAssignCftReducer: getAllAssignCftReducer,
    improvementPlanReducer: ImprovementPlanReducer,
    getAllVendorNeedApprovalReducer: getAllVendorNeedApprovalReducer,
    getAllSupplierNeedApproval: getAllSupplierNeedApproval,
    LegalDocumentReducer: LegalDocumentReducer,
    NsaListReducer: NsaListReducer,
    ViewDetailReportReducer: ViewDetailReportReducer,
    PendingAuditListReducer: PendingAuditListReducer,
    AllPendingForApprovalList: AllpendingForApprovalReducer,
    AllAwaitingForApprover: AllAwaitingForApprover,
    EmailTrackListReducer: EmailTrackListReducer,
    ReviewRequestResponseData: ReviewRequestResponseApproverReducer,
    ExceptionApprovalListReducer: ExceptionApprovalListReducer,
    VendorNeedFormApprovalList: VendorNeedFormApprovalList,
    VendorNeedFormPendingList: VendorNeedFormPendingList,
    NewRequestHistoryExport: NewRequestHistoryExport,
    SocMasterReducer: SocMasterReducer,
    SupplierCertificateMaster: SupplierCertificateMaster,
    ReconciliationReducer: ReconciliationReducer,
    AccountGroupMappingReducer: AccountGroupMappingReducer,
    CompanyCodeReducer: CompanyCodeReducer,
    UnblockListReducer: UnblockListReducer,
    BlockedSupplierRequest:BlockedSupplierRequest


}
export default mainReducer